// components/WeGrowTogetherSection.jsx
"use client";

import Image from "next/image";

export default function WeGrowTogetherSection() {
  return (
    <section className="relative w-full">
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <Image
          src="https://cdn.msu.edu.in/elearning_6670b730ec.png" // ⬅️ replace with your actual image
          alt="Group of happy students"
          fill
          priority
          className="object-cover"
        />
        {/* Dark gradient overlay from bottom */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/40 to-black/0" />
      </div>

      {/* Content */}
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
      {/* <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto"> */}
        <div className="flex min-h-[360px] sm:min-h-[420px] md:min-h-[480px] lg:min-h-[540px] items-end py-10 sm:py-12 md:py-16">
          <div className="max-w-3xl text-white pb-4 sm:pb-6 md:pb-10">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
              We Grow Together
            </h2>
            <p className="mt-4 text-sm sm:text-base leading-relaxed">
              We believe that every staff member of Medhavi Skill University
              stands as a significant pillar that holds together the institution
              of education. As a result of this, we believe in promoting and
              developing strength within all the pillars, to stand strong
              together through various training and team building adventures,
              which help refresh our staff members while at the same time
              growing together as a team.
            </p>
          </div>
        </div>
      </div>

   

      {/* Optionally: a simpler floating button for mobile could go here */}
    </section>
  );
}
